module.exports = __webpack_public_path__ + "static/publish-edf903e976be32d761d5916c7b8533d6.webp";